export const styles = `
  :host {
    display: block;
    font-family: Arial, sans-serif;
  }
  .login-overlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    }
  .login-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 480px;
    background-color: white;
    border-radius: 8px;
    z-index: 9999999;
    overflow: hidden;
    padding:32px 40px;
    box-sizing: border-box;
  }

  .login-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 14px;
    margin-bottom: 16px;
  }

  .login-header h2 {
    margin: 0;
    font-size: 20px;
    color: #333;
  }

  .close-btn {
    cursor: pointer;
    background:url('https://image.kmf.com/test/b6/81/b681d2306d0f3eb084bbd99595f87350.png') no-repeat;
    background-size: cover;
    width: 18px;
    height: 18px;
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .close-btn:hover {
    color: #333;
  }

  .login-tabs {
    display: flex;
    margin-bottom: 20px;
  }

  .tab {
    padding-bottom: 5px;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
    color: #333;
    transition: all 0.3s;
    font-weight:bold;
    margin-right:40px;
  }

  .tab.active {
    color: #4c91ff;
    border-bottom: 2px solid #4c91ff;
  }

  .login-content {

  }

  .input-group {
    position: relative;
    margin-top:15px;
  }

  input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;
  }

  input:focus {
    border-color: #4c91ff;
    outline: none;
  }

  .verification-group {
    display: flex;
  }

  .verification-input {
    flex: 1;
  }

  .verification-btn {
    width: 110px;
    margin-left: 10px;
    border: none;
    background-color: #4c91ff;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  .verification-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .login-footer {
    padding: 0 0 20px;
  }
    .login-footer-tips{
      padding:0;
      font-size: 12px;
    color: rgb(153, 153, 153);
    margin-bottom: 20px;
    margin-top: 10px;
    }
.login-footer-tips a{
 color: rgb(153, 153, 153);
 text-decoration: none;
}
 .login-footer-tips a:hover{
  color: #4c91ff;}
  .login-btn {
    width: 100%;
    padding: 12px 0;
    background-color: #4c91ff;
    border: none;
    border-radius: 4px;
    color: white;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .login-btn:hover {
    background-color: #3a7eea;
  }

  .login-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .agreement {
    margin-top: 15px;
    font-size: 12px;
    color: #666;
  }

  .agreement label {
    display: flex;
    align-items: center;
  }

  .agreement-checkbox {
    width: auto;
    margin-right: 5px;
  }

  .agreement a {
    color: #4c91ff;
    text-decoration: none;
  }

  /* 错误信息样式 */
  .error-message {
    color: #f44336;
    font-size: 12px;
    display: none;
    line-height: 1.5;
    padding-left: 2px;
    margin-top: 5px;
  }

  /* 带有错误消息的输入框 */
  .input-group:has(.error-message:not(:empty)) input {
    border-color: #f44336;
  }

  /* 区号选择器样式微调 */
  .area-code-selector {
    position: absolute;
    left: 0;
    top: 0;
    width: 150px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #ddd;
    border-right: none; /* 移除右边框 */
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    cursor: pointer;
    z-index: 1;
    box-sizing: border-box;
    padding: 0 8px;
  }

  .area-code-selector span {
    display: block;
    width: calc(100% - 12px); /* 为箭头留出空间 */
    text-align: left;
    font-size: 14px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
.area-code-selector::after {
  content: "";
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  margin-left: 4px;
}
  .phone-input {
    padding-left: 70px;

  }

  /* 确保所有带区号选择器的输入框样式一致 */
  .phone-input, 
  .username-input {
    padding-left: 150px; /* 调整左侧内边距，适应显示国家/地区名称 */
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
/* 当输入框获得焦点时，同时改变区号选择器的边框颜色 */
.input-group:focus-within .area-code-selector {
  border-color: #4c91ff;
}

/* 修复错误状态下的一体化边框 */
.input-group:has(.error-message:not(:empty)) .area-code-selector {
  border-color: #f44336;
}
  /* 修复区号下拉菜单样式 */
  .area-code-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 160px;
    max-height: 200px;
    overflow-y: auto;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    display: none;
    z-index: 100;
  }

  .area-code-option {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
  }

  .area-code-option:hover {
    background: #f5f5f5;
  }

  .area-code-loading,
  .area-code-empty {
    padding: 10px;
    text-align: center;
    color: #999;
  }

  /* 滑块容器样式 */
  #captcha {
  position: relative;
    margin-top: 10px;
    min-height: 30px;
  }

  /* 密码输入框组样式 */
  .password-group {
    position: relative;
  }

  .password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }

  .password-toggle:hover .eye-icon path {
    fill: #666;
  }

  .password-toggle:focus {
    outline: none;
  }

  .password-input {
    padding-right: 40px;
  }

  /* 调整眼睛图标样式 */
  .eye-icon {
    display: block;
  }
    .other-tips{
      position: absolute;
      bottom: 0;
      width: 100%;
      left: 0;
      right: 0;
      background-color: #f9f9f9;
      border-radius: 0 0 8px 8px;
      padding: 16px 0;
      font-size:12px;
      color: #999999;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
      text-decoration: none;
    }
      .other-tips span{
        width:12px;
        height:12px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAdVBMVEUAAACqqqqioqKVlZWdnZ2cnJydnZ2bm5uZmZmampqYmJiampqampqZmZmYmJiZmZmZmZmZmZmZmZmampqZmZmZmZmYmJiZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmWQOiCAAAAJnRSTlMAAwsMDRIaHCMmSk5TVVlaa251g5uqrrG2wcrS2dzd4/Lz+vv8/aBaSYYAAADHSURBVCjPdVLRAoIgDJxZKlmhpmRFiSb3/5+YooJm7ondwW27QTREmJSyrmWZhDSPIG8xRpsHDo8VmoIz32e8aKDiCU81RDQlkYBOx/taZ3PdTGvzJlBY4B0D1dfJIUx6vFhGIO/6bJtB/4WrrdO0ISUohuz0cUyBhErwMTs7hqMkCUYrhkFSDZ9WjI96QeyeqA79Yd8RM6ndHVVkpVxxh5vitt0Zbtq1A94cbga0ljze0cISa6Ln/Zi4afv2orZXu/0Z/n2fLz1gGDBYxpgiAAAAAElFTkSuQmCC');
        background-repeat: no-repeat;
        background-size: cover;
      }
        .other-tips:hover{
        color: #4c91ff;
        }
        .other-tips:hover span{
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAdVBMVEUAAABVqv9Gi+hAlepOietHjvFOifVJifZJivBKjfJIivVLjfJKivNLivNKjPRKi/RKivNKi/NKi/JKivNKivNKjPNJi/NJivNKi/JKi/NKi/JKivNKi/NKi/NKivNKi/NKi/NLi/NKi/NKi/NKi/NKi/NKi/ObUzorAAAAJnRSTlMAAwsMDRIaHCMmSk5TVVlaa251g5uqrrG2wcrS2dzd4/Lz+vv8/aBaSYYAAADHSURBVCjPdVLRAoIgDJxZKlmhpmRFiSb3/5+YooJm7ondwW27QTREmJSyrmWZhDSPIG8xRpsHDo8VmoIz32e8aKDiCU81RDQlkYBOx/taZ3PdTGvzJlBY4B0D1dfJIUx6vFhGIO/6bJtB/4WrrdO0ISUohuz0cUyBhErwMTs7hqMkCUYrhkFSDZ9WjI96QeyeqA79Yd8RM6ndHVVkpVxxh5vitt0Zbtq1A94cbga0ljze0cISa6Ln/Zi4afv2orZXu/0Z/n2fLz1gGDBYxpgiAAAAAElFTkSuQmCC');
          }
`;
